import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectSurveys,
  selectIsLoading,
  selectLastSurvey,
  selectSurveysCount,
} from "redux-toolkit/surveys/selectors";
import {
  getSurveysAsync,
  getNextSurveysAsync,
} from "redux-toolkit/surveys/actions";

const useSurveys = (filters = {}) => {
  const [page, setPage] = useState(1);
  const dispatch = useDispatch();
  const surveys = useSelector(selectSurveys);
  const isLoading = useSelector(selectIsLoading);
  const last = useSelector(selectLastSurvey);
  const count = useSelector(selectSurveysCount);

  useEffect(() => {
    dispatch(getSurveysAsync(filters));
  }, [dispatch, filters]);

  const getNextPage = () => {
    if (last && count > surveys.length) {
      dispatch(getNextSurveysAsync({ last, filters }));
      setPage(page + 1);
    }
  };

  return {
    surveys,
    isLoading,
    hasMoreItems: count > surveys.length,
    page,
    count,
    setPage,
    getNextPage,
  };
};

export default useSurveys;
